import * as Path from "path";
import CGReactPage from "./cgreact-page";
import CGReactComponent from "./cgreact-component";
import CGReactApplication from "./cgreact-application";
import {generateUUID} from "./cgreact-util";
/** 主类注解，只能用于CGReactApplication及其子类，按照配置初始化应用*/
// export function Main(classType: typeof CGReactApplication)
// {
//     //@ts-ignore 此注解默认只能给CGReactApplication用，加上as any则子类也可以用
//     return new class extends classType {} as any;
// }
/** 生效样式的注解，可以直接生效普通css文件路径，也可以生效JSS*/
export function affectStyle(style: string | JSS, tag?: string)
{
    return function (target: CGReactComponent | CGReactPage | CGReactApplication, propertyKey: string, descriptor: PropertyDescriptor)
    {
        // 只有在CGReactPage或者CGReactComponent中才进行处理
        if (!(target instanceof CGReactPage || target instanceof CGReactComponent || target instanceof CGReactApplication))
        {
            console.error("affectStyle注解必须配置在CGReactPage或者CGReactComponent中");
            return;
        }
        let rightNameSet: Set<string> = new Set();
        rightNameSet.add("renderView");
        rightNameSet.add("renderErrorView");
        rightNameSet.add("renderLoadingView");
        rightNameSet.add("renderApplicationPageView");
        rightNameSet.add("renderPageDefaultErrorView");
        rightNameSet.add("renderPageDefaultLoadingView");
        rightNameSet.add("renderComponentDefaultLoadingView");
        if (!rightNameSet.has(propertyKey.trim()))
        {
            console.error("affectStyle注解必须配置renderView方法上");
            return;
        }
        switch (typeof style)
        {
            case "string":
            {
                if (Path.extname(style) == ".css")
                {
                    // 用户想要生效一个css样式
                    tag = tag ? tag : style; //tag按照用户配置，没有就是style的路径
                    target.CSSStyle = target.CSSStyle ? target.CSSStyle : {}; //保障已经初始化
                    target.CSSStyle[tag] = style; //保存样式标签和地址
                } else
                {
                    tag = tag ? tag : generateUUID().substring(0, 5);
                    target.SCSSStyle = target.SCSSStyle ? target.SCSSStyle : {}; //保障已经初始化
                    target.SCSSStyle[tag] = style; //保存样式标签和地址
                }
                return;
            }
            case "object":
            {
                // 用户想要生效一个JSS样式
                tag = tag ? tag : target.constructor.name; //tag按照用户配置，没有就用构造函数名
                target.JSSStyle = target.JSSStyle ? target.JSSStyle : {}; //保障已经初始化
                target.JSSStyle[tag] = style;
                return;
            }
            default:
            {
                console.error("affectStyle注解第1参数必须是一个有效的路径或者JSS");
                return;
            }
        }
    }
}
